/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * Mealean API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { GetSessionUser200, GetTenantById200, GetTenantByIdParams, GetTenantByIdPathParameters } from '.././model';

import { apiInstance } from '../../instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getSessionUser = (options?: SecondParameter<typeof apiInstance>, signal?: AbortSignal) => {
	return apiInstance<GetSessionUser200>({ url: `/session/user`, method: 'GET', signal }, options);
};

export const getGetSessionUserQueryKey = () => {
	return [`/session/user`] as const;
};

export const getGetSessionUserQueryOptions = <
	TData = Awaited<ReturnType<typeof getSessionUser>>,
	TError = unknown,
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
	request?: SecondParameter<typeof apiInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSessionUserQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionUser>>> = ({ signal }) =>
		getSessionUser(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSessionUser>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSessionUserQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionUser>>>;
export type GetSessionUserQueryError = unknown;

export function useGetSessionUser<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSessionUser>>,
					TError,
					Awaited<ReturnType<typeof getSessionUser>>
				>,
				'initialData'
			>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSessionUser<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSessionUser>>,
					TError,
					Awaited<ReturnType<typeof getSessionUser>>
				>,
				'initialData'
			>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSessionUser<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSessionUser<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSessionUserQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetSessionUserSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getSessionUser>>,
	TError = unknown,
>(options?: {
	query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
	request?: SecondParameter<typeof apiInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSessionUserQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSessionUser>>> = ({ signal }) =>
		getSessionUser(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getSessionUser>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSessionUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSessionUser>>>;
export type GetSessionUserSuspenseQueryError = unknown;

export function useGetSessionUserSuspense<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options: {
		query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSessionUserSuspense<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSessionUserSuspense<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSessionUserSuspense<TData = Awaited<ReturnType<typeof getSessionUser>>, TError = unknown>(
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSessionUser>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSessionUserSuspenseQueryOptions(options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

export const getTenantById = (
	{ identifier }: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: SecondParameter<typeof apiInstance>,
	signal?: AbortSignal
) => {
	return apiInstance<GetTenantById200>({ url: `/session/${identifier}`, method: 'GET', params, signal }, options);
};

export const getGetTenantByIdQueryKey = ({ identifier }: GetTenantByIdPathParameters, params?: GetTenantByIdParams) => {
	return [`/session/${identifier}`, ...(params ? [params] : [])] as const;
};

export const getGetTenantByIdQueryOptions = <TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	{ identifier }: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetTenantByIdQueryKey({ identifier }, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantById>>> = ({ signal }) =>
		getTenantById({ identifier }, params, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!identifier, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getTenantById>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTenantByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantById>>>;
export type GetTenantByIdQueryError = unknown;

export function useGetTenantById<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	pathParams: GetTenantByIdPathParameters,
	params: undefined | GetTenantByIdParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getTenantById>>,
					TError,
					Awaited<ReturnType<typeof getTenantById>>
				>,
				'initialData'
			>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTenantById<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	pathParams: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getTenantById>>,
					TError,
					Awaited<ReturnType<typeof getTenantById>>
				>,
				'initialData'
			>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTenantById<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	pathParams: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTenantById<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	{ identifier }: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTenantByIdQueryOptions({ identifier }, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTenantByIdSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getTenantById>>,
	TError = unknown,
>(
	{ identifier }: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetTenantByIdQueryKey({ identifier }, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantById>>> = ({ signal }) =>
		getTenantById({ identifier }, params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getTenantById>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTenantByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantById>>>;
export type GetTenantByIdSuspenseQueryError = unknown;

export function useGetTenantByIdSuspense<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	pathParams: GetTenantByIdPathParameters,
	params: undefined | GetTenantByIdParams,
	options: {
		query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTenantByIdSuspense<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	pathParams: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTenantByIdSuspense<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	pathParams: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTenantByIdSuspense<TData = Awaited<ReturnType<typeof getTenantById>>, TError = unknown>(
	{ identifier }: GetTenantByIdPathParameters,
	params?: GetTenantByIdParams,
	options?: {
		query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTenantById>>, TError, TData>>;
		request?: SecondParameter<typeof apiInstance>;
	},
	queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTenantByIdSuspenseQueryOptions({ identifier }, params, options);

	const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
